export default {
  // 主页面
  collaborationPage: "合作管理",
  coldEmail: "邮件营销",
  reportAndPayout: "报告与结算",
  report: "报告",
  budgetLabel: "预算",
  campaignInfoPage: "计划信息",
  campaignInfo: "计划信息",

  // 状态相关
  status: {
    active: "进行中",
    paused: "已暂停",
    draft: "草稿",
    ended: "已结束",
    predicting: "预测中",
    completed: "已完成",
    cancelled: "已取消",
    reviewing: "审核中",
    rejected: "未通过",
  },

  // 操作按钮
  actions: {
    pause: "暂停",
    resume: "继续",
    edit: "编辑",
    close: "关闭",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    reset: "重置",
    back: "返回",
  },

  // 预算相关
  budget: {
    title: "预算",
    currentBudget: "当前预算",
    remainingBudget: "剩余预算",
    spentBudget: "已用预算",
    changeBudget: "调整预算",
    budgetLimit: "预算上限",
    monthlyBudget: "月度预算",
    totalBudget: "总预算",
    influencerBudget: "达人预算",
    affiliateBudget: "分销预算",
    coldEmailBudget: "邮件营销预算",
    continueBudget: "继续使用预算",
    cancelBudget: "取消预算",
    updateBudget: "更新预算",
    budgetHistory: "预算记录",
    budgetCycle: "预算周期",
    nextCycle: "下个周期",
    currentCycle: "当前周期",
  },

  // 反馈相关
  feedback: {
    title: "意见反馈",
    submitFeedback: "提交反馈",
    submitFeedbackHere: "在此提交反馈",
    pleaseEnterFeedback: "请填写您的反馈",
    feedbackPlaceholder: "告诉我，如何进一步优化本次活动的达人匹配效果？",
    feedbackSubmitted: "反馈提交成功，感谢您的支持！",
    submitNewFeedback: "再提交一条反馈",
    sendFeedback: "发送反馈",
  },

  // 指南卡片
  guide: {
    title: "活动指南",
    description: "学习如何优化设定营销计划",
    viewGuide: "查看指南",
    instructions: "操作说明",
  },

  // 暂停相关
  pause: {
    resumeCampaign: "恢复计划",
    title: "由于处于非活动状态，您的活动",
    title2: "已暂停",
    content: "要继续匹配并推进流程，请立即恢复计划。",
  },

  // 预算不足提醒
  budgetAlert: {
    title: "预算提醒",
    insufficientBudget: "当前周期预算不足",
    addBudget: "追加预算",
    upgradePlan: "升级方案",
    lowBudgetTitle: "您的活动 {name} 预算不足",
    lowBudgetDesc:
      "预算直接影响可邀请的达人数量和单价上限，提升预算，解锁更多合作机会，获得更佳效果。",
    pausedTitle: "该活动当前已暂停",
    pausedDesc: "如需优化活动设置或启动新活动，请随时联系我们的客户支持团队。",
  },

  // 预算页面相关
  budgetPage: {
    title: "预算",
    renewalSuccessful: "续费成功！",
    accountFrozen: "您的账户已被冻结",
    changeSuccess: "预算调整成功",
    cancelSuccess: "活动取消成功",
    raiseMaxCpm: "提升最高 CPM 以充分使用广告预算",
    currentAdSpend: "当前广告支出：{cost}",
    youtubeDedicated: "YouTube 全片：{price}",
    youtubeIntegrated: "YouTube 插片：{price}",
    tiktokVideo: "TikTok 视频：{price}",
    influencerMarketingBudget: "达人营销预算",
    viewBillingHistory: "查看账单记录",
    costToDate: "累计支出",
    budget: "预算",
    affiliateRecruitmentBudget: "分销招募预算",
    continueWithBudget: "继续使用 {budget} 预算",
    continueAndModify: "继续并修改预算",
    cancel: "取消",
    renewCampaign: "续费活动",
    coldEmailBudget: "邮件营销预算",
    continueModifyTitle: "继续并修改预算",
    confirm: "确认",
    monthlySpendingLimit:
      "月度支出上限为您在单月内用于活动的最高金额。我们会根据当月确认的预期点击量进行扣费。",
    termination: "终止",
    cancelCampaign: "确定取消此活动？",
    cancelCampaignDesc: "取消后将无法恢复，请谨慎操作。",
    change: "修改",
    yes: "是",
    no: "否",
    instagramReel: "Instagram Reels：{price}",
    twitterPost: "Twitter / X 帖子：{price}",
    linkedinPost: "LinkedIn 帖子：{price}",
    influencerMarketingBudgetTooltip: "您的预算决定了可以邀请多少达人参与活动。如果您希望 AI 匹配更多达人并最大化活动效果，可以提高预算。",
  },

  // 审核拒绝提醒
  reviewAlert: {
    title: "审核提醒",
    campaignRejected: "该营销计划未通过审核",
    reviewReason: "审核原因",
    resubmit: "重新提交",
  },

  // 充值相关
  recharge: {
    title: "限时优惠",
    description: "活动上线后 5 天内充值，可获赠广告额度。支持随时 100% 退款。",
    rechargeNow: "立即充值",
    skipForNow: "暂不使用",
    depositNow: "立即充值 {total}，获赠 {credits} 广告额度",
  },

  // 最大CPM相关
  maxCpm: {
    title: "最高 CPM",
    platform: "平台",
    price: "价格",
    youtubeDedicated: "YouTube 专属视频",
    youtubeIntegrated: "YouTube 插片视频",
    tiktokVideo: "TikTok 视频",
    instagramReel: "Instagram Reels",
    instagramCarouselPost: "Instagram 图文贴子",
    twitterPost: "Twitter 帖子",
    linkedinPost: "LinkedIn 帖子",
  },

  // 时间相关
  time: {
    currentTime: "当前时间",
    startDate: "开始日期",
    endDate: "结束日期",
    progress: "进度",
    remainingDays: "剩余天数",
  },

  // 消息提示
  messages: {
    campaignPaused: "活动已暂停",
    campaignResumed: "活动已恢复",
    budgetUpdated: "预算更新成功",
    feedbackSubmitted: "反馈提交成功，感谢您的支持！",
    operationFailed: "出了一点小问题，请稍后再试",
    pleaseWait: "请稍候...",
    loading: "加载中...",
    noData: "暂无数据",
  },

  // 表单验证
  validation: {
    required: "此字段为必填项",
    invalidNumber: "请输入有效的数字",
    invalidEmail: "请输入有效的邮箱地址",
    minLength: "至少输入 {min} 个字符",
    maxLength: "最多可输入 {max} 个字符",
  },

  // 通用
  common: {
    yes: "是",
    no: "否",
    ok: "好的",
    close: "关闭",
    loading: "加载中",
    error: "错误",
    success: "成功",
    warning: "提醒",
    info: "提示",
    confirm: "确认",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    view: "查看",
    add: "添加",
    remove: "移除",
    searchData: "搜索",
    filterData: "筛选",
    sort: "排序",
    refresh: "刷新",
    exportData: "导出",
    import: "导入",
    downloadData: "下载",
    upload: "上传",
  },

  // 主页面相关
  mainPage: {
    campaignCanceled: "营销计划已取消",
    campaignCanceledDescription:
      "很遗憾，您的活动因支付未完成而被取消。但已建立的合作仍可继续。如需帮助，请联系支持团队。",
    fold: "收起",
    headInstructions: "使用指南",
    headInstructionsDesc: "活动启动后，您可以期待以下内容",
    headAcademy: "AhaCreator 学院",
    headAcademyDesc: "在 YouTube 观看完整教程",
  },

  // 合作页面相关
  collaboration: {
    title: "合作管理",
    creatorList: "达人列表",
    invitedList: "已邀请达人",
    todoList: "待办事项",
    searchCollaboration: "搜索",
    filterCollaboration: "筛选",
    statusCollaboration: "状态",
    platformCollaboration: "平台",
    regionCollaboration: "地区",
    languageCollaboration: "语言",
    nameCollaboration: "姓名",
    followers: "粉丝数",
    engagement: "互动率",
    priceCollaboration: "报价",
    actionsCollaboration: "操作",
    invite: "邀请",
    accept: "接受",
    reject: "拒绝",
    pendingCollaboration: "待处理",
    approved: "已批准",
    rejected: "已拒绝",
    completed: "已完成",
    viewCollaboration: "查看",
    editCollaboration: "编辑",
    deleteCollaboration: "删除",
    downloadCollaboration: "下载",
    exportCollaboration: "导出",
    noDataCollaboration: "暂无数据",
    loadingCollaboration: "加载中...",
    errorCollaboration: "出错了",
    successCollaboration: "操作成功",
    // 标签页选项
    invitedInfluencers: "已邀请达人",
    establishedCollaborations: "已建立合作",
    confirmInviteList: "待确认邀约列表",
    all: "全部",
    pendingConfirmation: "新候选人",
    priceNegotiation: "价格谈判",
    pendingKickoff: "待启动",
    scriptUnderProduction: "脚本制作中",
    contentUnderProduction: "内容制作中",
    pendingPublish: "待发布",
    adsPublished: "广告已发布",
    canceled: "已取消",
    // 新增翻译键
    inviteTemplates: "邀约模版",
    influencer: "达人",
    inviteEmailTemplate: {
      button: "邀请邮件模板",
      title: "邀请邮件模板",
      description: "AhaCreator 拥有数万种多样化的邮件模板。这些模板已在数百万真实订单中得到验证，始终提供最强的响应和转化表现。以下是 5 个邀请示例：",
      tooltip: "完成达人邀请后，邮件模板查看功能将自动启用。",
    },
    trialBatchTip:
      "AhaCreator 已为您邀请了一批试用达人，您将收到 3–5 个初始申请。要解锁完整访问，请",
    startCollaboration: "与任意达人开始合作",
    or: "或",
    depositBudget: "充值营销预算",
    earnMoreCredits: "正式启动您的营销计划",
    campaignProgress: {
      reviewCampaign: "审核活动",
      matchInfluencers: "匹配达人",
      negotiatePriceAndSettleContract: "谈判价格 & 签订合约",
      viewInfluencerApplication: "查看达人申请",
      reviewCampaignActiveDesc: "平台将在 24 小时内审核您的活动",
      reviewCampaignAfterDesc: "活动已审核通过并正式启动",
      matchInfluencersBeforeDesc: "AI 正在匹配最佳达人并为您发送邀约",
      haveBeenMatched: "已匹配",
      matchInfluencersActiveDesc: "AI 正在为你筛选顶级达人，并自动发送合作邀请",
      negotiatePriceAndSettleContractBeforeDesc: "AI 会帮你与网红谈判，拿到最优惠的合作价格，并为你完成合同签署",
      negotiatePriceAndSettleContractActiveDesc: "AI 正在谈判价格并签订合约",
      viewInfluencerApplicationBeforeDesc: "您可以在“已建立合作”标签页下方查看申请",
      viewInfluencerApplicationActiveDesc: "已提交申请",
      viewPlatformDetails: "查看平台详情",
      viewApplication: "查看申请",
    }
  },

  // 活动信息页面相关
  campaignInfoDetails: {
    title: "计划信息",
    basicInfo: "基本信息",
    settings: "设置",
    details: "详情",
    statusCampaignInfo: "状态",
    startDate: "开始日期",
    endDate: "结束日期",
    budgetCampaignInfo: "预算",
    objective: "目标",
    target: "受众",
    platformCampaignInfo: "平台",
    audience: "受众",
    creative: "创意",
    editCampaignInfo: "编辑",
    saveCampaignInfo: "保存",
    cancelCampaignInfo: "取消",
    deleteCampaignInfo: "删除",
    viewCampaignInfo: "查看",
    noDataCampaignInfo: "暂无数据",
    loadingCampaignInfo: "加载中...",
    errorCampaignInfo: "出错了",
  },

  // 活动详情面板相关
  panel: {
    reminder: "提醒",
    editWarning: "计划已上线，部分信息暂不可编辑。",
    edit: "编辑",
    resumed: "已恢复",
    objective: "目标",
    startedOn: "开始于",
    currentCycle: "当前周期",
    editCampaign: "编辑活动",
    resume: "继续",
    pause: "暂停",
    paused: "已暂停",
    reject: "拒绝",
    approve: "批准",
    rejectTitle: "拒绝",
    rejectCampaign: "拒绝营销计划",
    rejectionReason: "拒绝原因",
    rejectionReasonDesc: "请向广告主说明拒绝原因。",
    enterRejectReason: "请输入拒绝原因",
    successfully: "操作成功！",
  },

  // 最大CPM预算相关
  maxCpmBudget: {
    headerTitle: "提升 CPM，充分利用广告预算",
    closeText: "稍后再说",
    description:
      "基于当前最高 CPM 设置，您的广告支出为 {cost} 美元。为更充分地使用预算，建议将最高 CPM 调整为：",
    approveChanges: "是否同意以上调整？",
    platforms: {
      youtubeDedicated: "YouTube 专属视频",
      youtubeIntegrated: "YouTube 插播视频",
      tiktokVideo: "TikTok 视频",
      instagramReel: "Instagram Reels",
      twitterPost: "Twitter / X 帖子",
      linkedinPost: "LinkedIn 帖子",
    },
  },

  // 受众页面相关
  audience: {
    title: "受众",
    edit: "编辑",
    mode: "模式",
    smartMatchMode: "智能匹配模式",
    manualMode: "手动模式",
    smartMatchDesc:
      "交给 AI 代理：优先触达高优先级受众；若达人不足，将逐步扩大覆盖范围。",
    manualModeDesc:
      "手动选择受众：可参考平台推荐；如达人不足，需要您手动补充更多受众。",
    showMore: "展开更多",
  },

  // 活动创意页面相关
  campaignIdeas: {
    title: "营销创意",
    edit: "编辑",
  },

  // 活动信息编辑页面相关
  campaignInformationEdit: {
    title: "计划信息",
    cancel: "取消",
    save: "保存",
    campaignName: "计划名称",
    internalNote: "内部备注",
    influencerBudget: "达人预算",
    affiliateRecruitmentBudget: "分销招募预算",
    coldEmailOutreachBudget: "邮件营销外联预算",
    platform: "平台",
    country: "国家/地区",
    languages: "语言",
    influencerMarketingPostDate: "达人营销发布日期",
    businessName: "品牌/公司名称",
    website: "网站",
    benchmarkBrands: "对标品牌",
    productIntro: "产品简介",
    coreSellingPoints: "核心卖点",
    coreAudiences: "核心产品受众",
    budgetPerInfluencer: "单个达人预算",
    maximumCpm: "最高 CPM",
    selectAll: "全选",
    flexiblePostTime: "灵活发布时间：达人内容通过后即可发布。",
    fixedPostTime: "固定发布时间：达人需在指定时间窗口内发布。",
    letAiAgentSetCpm: "交由 AI 代理设置 CPM",
    setMaximumCpmManually: "手动设置最高 CPM",
    regenerateOptimizedAudiences: "重新生成优化受众？",
    regenerateAudiencesDesc:
      "检测到您修改了可能影响优化受众的信息，是否立即重新生成？",
    notNow: "暂不",
    confirm: "确认",
    gotIt: "知道了",
    campaignUpdated: "活动已更新！我们将按最新设置邀请达人，申请将很快到达。",
    // 表单验证消息
    pleaseEnterCampaignName: "请输入计划名称",
    maximum50Characters: "最多可输入 50 个字符。",
    pleaseSelectBudget: "请选择预算",
    pleaseSelectAtLeastOnePlatform: "请至少选择一种平台内容类型",
    pleaseSelectAtLeastOneRegion: "请至少选择一个地区",
    pleaseEnterBenchmarkBrands: "请输入对标品牌",
    pleaseEnterElevatorPitch: "请输入电梯陈述",
    pleaseSelectPostDate: "请选择发布日期",
    pleaseEnterBusinessName: "请输入品牌/公司名称",
    campaignIntroduction: "活动简介",
    // 提示信息
    platformTooltip: "选择达人的社媒平台和内容形式",
    languageTooltip: "输入语言，以便向使用该语言的人群营销",
    postDateTooltip: "如有指定的发布时间窗，请在此设置。",
    benchmarkBrandsDesc: "我们会优先推荐与这些品牌合作过且数据好或受众相近的达人。",
    productIntroPlaceholder: "请简要描述产品核心价值与亮点，简洁有力。",
    businessNamePlaceholder: "请输入品牌/公司名称",
    benchmarkBrandsPlaceholder: "请输入对标品牌",
    // 日期选择器提示
    selectCampaignStartDates:
      "建议至少提前一个月设置开始日期，确保达人有充足时间制作内容。",
    // 平台限制警告
    platformLimitWarning:
      "当前平台选择可能合适的达人数量有限。为提升效果，建议适当增加平台类型。",
    recommend: "我们会推荐与这些品牌合作过或受众相似的达人。",
    // 匹配准确度模态框
    matchingAccuracyModal: {
      switchToFocusMode: "切换到专注模式？",
      switchToMaxScaleMode: "切换到最大规模模式？",
      switchToScaleMode: "切换到规模模式？",
      focusModeDescription: "这将缩小达人池范围以提高匹配精度，可能会增加成本并延长活动周期。最适合高度细分的小众活动。",
      maxScaleModeDescription: "这将扩大达人池范围以帮助降低成本并加速活动执行，但可能会降低整体匹配精度。最适合面向广泛受众的活动。",
      switchToScaleFromFocusDescription: "切换到规模模式将扩大达人池范围，同时保持相关性，在效率、成本和活动速度之间提供平衡。",
      switchToScaleFromMaxScaleDescription: "与最大规模模式相比，这将缩小达人池范围，同时保持相关性——在效率、成本和活动速度之间提供平衡的权衡。",
      confirmSwitch: "确认切换",
      focusModeWarning: "重要提示：切换到专注模式将重新计算达人匹配。一些不再符合条件的现有邀请和申请将被移除。请谨慎操作。",
      scaleModeWarningFromMaxScale: "重要提示：切换到规模模式将重新计算达人匹配。一些不再符合条件的现有邀请和申请将被移除。请谨慎操作。"
    }
  },

  // 活动信息预览页面相关
  campaignInformationPreview: {
    title: "计划信息",
    edit: "编辑",
    campaignName: "计划名称",
    internalNote: "内部备注",
    influencerMarketingBudget: "达人营销预算",
    affiliateRecruitmentBudget: "分销招募预算",
    coldEmailBudget: "邮件营销预算",
    influencerMarketingBudgetTooltip: "您的预算决定了 AI 可以邀请多少达人。如果您希望 AI 匹配更多达人并最大化您的活动效果，请增加预算。",
    country: "国家/地区",
    language: "语言",
    platform: "平台",
    placements: "营销平台选择",
    audienceLinkTitle: "请提供受众点击后跳转的链接",
    affiliateCommissionRate: "分销佣金比例",
    influencerMarketingPostDate: "达人营销发布日期",
    affiliateMarketingPostDate: "分销营销发布日期",
    fixedPostTime: "固定发布时间：达人需在指定时间窗口内发布。",
    flexiblePostTime: "灵活发布时间：达人内容通过后即可发布。",
    affiliatePostTime: "达人申请通过后需在 7 日内发布内容",
    importantMatters: "重要事项",
    campaignResultsEstimation: "活动效果预估",
    estimationDescription: "以下为预测数据，实际结果以最终达人成效为准。",
    businessName: "品牌/公司名称",
    website: "网站",
    benchmarkBrands: "对标品牌",
    productServiceType: "产品/服务类型",
    productIntro: "产品简介",
    productValue: "产品价值",
    coreSellingPoints: "核心卖点",
    coreAudiences: "核心产品受众",
    budgetPerInfluencer: "单个达人预算",
    maximumCpm: "最高 CPM",
  },
  // 其他信息编辑页面相关
  otherInformationEdit: {
    title: "其他信息",
    cancel: "取消",
    save: "保存",
    coldEmailOutreach: "邮件营销联系",
    coldEmailOutreachDesc: "此名称将作为邮件营销的发件人名称显示",
    emailSenderName: "发件人名称",
    emailSenderTitle: "发件人头衔",
    emailToForwardLeads: "线索转交邮箱",
    emailSenderNamePlaceholder: "该名称将作为冷邮件的发件人名称",
    emailSenderTitlePlaceholder: "该头衔将与发件人名称一同显示",
    emailForwardPlaceholder: "我们会把优质的转化线索转发至该邮箱",
    customBrandGuidelines: "自定义品牌规范",
    customBrandGuidelinesCampaignBrief: "自定义品牌规范 / brief",
    add: "添加",
    blocklist: "屏蔽名单",
    blocklistDesc: "上传您不希望合作的达人名单。",
    downloadTemplate: "下载模板",
    upload: "上传",
    referenceInfluencers: "参考达人",
    referenceInfluencersDesc:
      "上传您喜欢的达人列表，AhaCreator 将为您的活动寻找相似达人。",
    brandAssets: "品牌素材",
    brandAssetsPlaceholder: "请输入品牌素材链接…",
    productExplainerVideo: "产品讲解视频",
    // ProductDelivery.tsx extra
    fileSizeExceed5MB: "文件大小不可超过 5 MB！",
    uploadProductPhotoFailed: "产品照片上传失败",
    pleaseSelect: "请选择",
    pleaseEnterProductName: "请输入产品名称",
    uploadProductPhotos: "上传产品照片",
    uploadPhotoHint: ".JPG、.JPEG 或 .PNG，最大 5MB。",
    pleaseUploadProductPhotos: "请上传产品照片",
    pleaseEnterProductCashValue: "请输入产品零售价",
    productVideoPlaceholder:
      "例如：https://youtu.be/nXyPLFQeddA?si=EoO5X98IP5lZ1sw8",
    influencerAutoApproval: "达人自动通过",
    autoApprovalDesc: "符合您设置条件的达人将自动通过并进入内容制作。",
    matchingScore: "匹配分",
    matchingScoreAbove: "匹配分高于",
    cpmBelow: "CPM 低于",
    cpcBelow: "CPC 低于",
    // 表单验证消息
    pleaseEnterEmailSenderName: "请输入发件人名称",
    pleaseEnterEmailSenderTitle: "请输入发件人头衔",
    pleaseEnterEmailForward: "请输入线索转交邮箱",
    pleaseEnterValidEmail: "请输入有效的邮箱地址",
    pleaseInputValidLink: "请输入有效链接！",
    pleaseInputValidYoutubeLink: "请输入有效的 YouTube 链接！",
    pleaseFillCriteriaForAllPlatforms: "提交前请为所有平台填写筛选条件。",
    // 错误消息
    fileDoesNotContainInfluencerProfile: "文件中未包含任何达人资料",
  },

  // 其他信息预览页面相关
  otherInformationPreview: {
    title: "其他信息",
    edit: "编辑",
    productDelivery: "是否寄样",
    iWillShipProduct: "我将寄送样品",
    noShipmentNeeded: "我不寄送样品",
    shipProductDescription:
      "您需要分别向每位达人寄送产品，并在平台提供必要的物流信息。达人收货后将开始创作内容。",
    productName: "产品名称",
    productRetailPrice: "产品零售价",
    productPhoto: "产品图片",
    coldEmail: "邮件营销",
    emailSenderName: "发件人名称",
    emailSenderTitle: "发件人头衔",
    emailToForwardLeads: "线索转交邮箱",
    customBrandGuidelines: "自定义品牌规范",
    blocklist: "屏蔽名单",
    blocklistDesc: "上传您不希望合作的达人名单。",
    downloadTemplate: "下载模板",
    referenceInfluencers: "参考达人",
    referenceInfluencersDesc:
      "上传您喜欢的达人列表，AhaCreator 将为您的活动寻找相似达人。",
    brandAssets: "品牌素材",
    productExplainerVideo: "产品讲解视频",
    // ProductDelivery.tsx extra（预览页运行时也会用到）
    fileSizeExceed5MB: "文件大小不可超过 5 MB！",
    uploadProductPhotoFailed: "产品照片上传失败",
    pleaseSelect: "请选择",
    pleaseEnterProductName: "请输入产品名称",
    uploadProductPhotos: "上传产品照片",
    uploadPhotoHint: ".JPG、.JPEG 或 .PNG，最大 5MB。",
    pleaseUploadProductPhotos: "请上传产品照片",
    pleaseEnterProductCashValue: "请输入产品零售价",
    productOptionsForInfluencerSelection: "影响者选择的产品选项",
    pleaseEnterProductOptions: "请输入影响者选择的产品选项",
    optionalGuidanceForInfluencerSelection: "影响者选择的可选指南",
    pleaseEnterOptionalGuidance: "请输入影响者选择的可选指南",
    addImage: "添加图片",
    addProductOption: "添加产品选项",
    requireCreatorRegistrationDesc: "达人需先在您的产品上注册，再提供其注册邮箱/用户ID以获取访问权限。",
    influencerAutoApproval: "达人自动通过",
    autoApprovalDesc: "符合您设置条件的达人将自动通过并进入内容制作。",
    matchingScore: "匹配分",
    matchingScoreAbove: "匹配分高于",
    cpmBelow: "CPM 低于",
    cpcBelow: "CPC 低于",
    ideaScriptSubmission: "创意框架/文字脚本提交",
    ideaScriptSubmissionDesc: '此更新仅适用于新的达人合作。已开始的合作无法更新，将继续遵循原始条款。',
    ideaScriptCreateText: "如果需要，达人应在开始制作前必须提交文字稿想法或脚本以确保内容方向一致。",
    productDeliveryDescription: "您需要分别向每位达人寄送产品，并在平台提供必要的物流信息。达人收货后将开始创作内容。",
    productOptionsPhoto: "产品选项照片",
    productOptionsForInfluencerSelectionDesc: "添加影响者可以选择的产品选项（例如：尺寸、颜色、容量）",
    optionalGuidanceForInfluencerSelectionDesc: "添加指导帮助影响者做出正确选择（例如：尺寸提示、颜色建议）",
  },

  // AI代理列表相关
  aiAgentLists: {
    reviewCampaignInfo: "正在审核本次营销计划信息… 请在 24 小时内提供反馈",
    reviewedCampaignInfo: "已完成活动信息审核，活动已通过",
    matchInfluencers: "从达人库中为您匹配合适的达人",
    matchTikTokInfluencers: "匹配 TikTok 达人",
    matchTikTokBody: "已匹配的 TikTok 达人数：",
    matchYouTubeInfluencers: "匹配 YouTube 达人",
    matchYouTubeBody: "已匹配的 YouTube 达人数：",
    identifyContactInfo: "识别达人联系方式并发送邀请",
    sendInvitesYouTube: "向 YouTube 达人发送邀请",
    sendInvitesYouTubeBody: "已识别 YouTube 达人联系方式，邀请已发送",
    sendInvitesTT: "向 TikTok 达人发送邀请",
    sendInvitesTTBody: "已识别 TikTok 达人联系方式，邀请已发送",
    negotiateInfluencers: "与有意向的达人谈判价格并签订合约",
    negotiateWithInfluencers: "与达人谈判",
    negotiateBody: "部分达人已表示兴趣，AhaCreator 正在为您争取更优价格",
    settleContract: "签订合约",
    settleContractBody: "与已确认价格的达人签订合约",
    influencersApplied:
      "已收到达人的申请。如果您对这些达人有任何反馈，请告诉我们，以便更好地匹配您的需求。",
  },

  // 调整提示相关
  adjustAlert: {
    description:
      "您当前看到的是红人实例。若需正式启动本次营销计划，请立即充值。",
    adjustInputs: "没有看到理想的匹配？试试调受众画像。",
  },

  // 广告活动营销策略标签页相关
  adsCampaignMarketingStrategyTabs: {
    affiliatesMarketing: "分销营销",
    influencerMarketing: "达人营销",
  },

  // 创作者列表相关
  creatorList: {
    depositFundsNow: "立即充值",
    moreInfluencers: "更多达人",
    areWaitingToCollaborate: "正在等待与您合作 — 只需",
    collaborationWithAnyCreator: "与任意达人开启合作",
    or: "或",
    depositYourCampaignBudget: "充值活动预算。",
    unlockFullAccess: "解锁完整访问",
    notSeeingIdealMatches: "没有看到理想的匹配？",
    adjustYourInputs: "试试调整筛选条件",
  },

  // 创作者表格列相关
  creatorTableColumns: {
    name: "姓名",
    aiRecommendationReasons: "AI 推荐理由",
    status: "状态",
    matchingScore: "匹配分",
    language: "语言",
    bestPrice: "提议价格",
    recruitmentCost: "招募成本",
    commissionRate: "佣金比例",
    lowestCpm: "最低 CPM",
    brandedContentPredictedViews: "品牌内容预测播放量",
    publishTime: "发布时间",
    starred: "已加星",
    wantBetterResults: "想要更好的效果？",
    matchingScoreDescription:
      "匹配分展示达人与活动设置的契合度，通常分数越高，结果越好。",
    lowerPrice: "主动降价",
    lowerPriceTooltip: "为表达强烈合作意愿，该达人将报价降至低于平台建议价。",
    higherPriceTooltipTitle: '最终价格确认',
    higherPriceTooltip: '该达人的报价高于平台指导价。我们的AI代理已积极协商并确认这是他们可接受的最低报价。',
    betterOffer: '优质报价',
    betterOfferTooltip: '该达人自愿降低其报价低于通常报价以进行此次合作。',
    addFavoriteTooltip: '添加到收藏',
    removeFromFavoriteTooltip: '移除收藏',
    removeCollaborationTooltip: '移除合作',
    confirmCollaborationTooltip: '确认合作',
    submitShippingInformationTooltip: '填写发货信息',
    reviewScriptTooltip: '审核脚本',
    reviewDraftTooltip: "审核草稿",
    lastUpdateTime: "最后更新时间",
    yourOffer: "你的报价",
    influencerCounter: "达人还价",
    influencerFirstRate: "达人首次报价",
  },

  // 创作者表格日期选择器相关
  creatorTableDatePicker: {
    startUpdateTime: '更新开始时间',
    endUpdateTime: '更新截止时间',
    placeholder: '选择更新时间',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastYear: '最近一年',
    selectDates: '选择日期',
    btnApply: '确定',
    btnCancel: '取消',
  },

  // 创作者表格语言选择器相关
  creatorTableSelectorLanguage: {
    allLanguages: "全部语言",
    languages: "语言",
  },

  // 创作者表格姓名选择器相关
  creatorTableSelectorName: {
    searchPlaceholder: "搜索达人姓名或账号",
  },

  // 创作者表格地区选择器相关
  creatorTableSelectorRegion: {
    allRegions: "全部地区",
    unknown: "未知",
  },

  // 创作者表格状态选择器相关
  creatorTableSelectorStatus: {
    allStatus: "全部状态",
    status: "状态",
  },

  // 空状态组件相关
  emptyComponent: {
    enterpriseSetupMessage:
      "您的企业邮箱域名正在配置与预热中，通常需要 7–14 天完成。",
    inviteTheInfluencersYouWantToWorkWith: '邀请您想合作的达人',
    youveChosenToReviewInviteListBeforeSendingInvites: '您已选择在发送邀请前审核邀请列表。为了保持活动顺利进行，请尽快检查邀请列表并确认。',
    checkNow: '立即查看',
    dontWorry: "别担心，",
    activelySendingInvitations: "我们正在积极向达人发送邀请",
    onceConfirmed: "。达人确认后会在这里展示。",
    normallyTakes: "通常该流程大约需要",
    processTime: "24–48 小时",
    toComplete: " 即可完成。特殊情况下可能更久，我们会尽快为您推进。",
  },

  // 邀请列表相关
  invitedList: {
    // 表格列标题
    name: "姓名",
    status: "状态",
    country: "国家/地区",
    language: "语言",
    other: "其他",
    // 全量达人外联提示
    fullOutreachLive: "您的活动已开启全量达人外联 — 请关注高质量的申请！",
    // 试用版提示
    depositFundsNow: "立即充值",
    moreInfluencersWaiting: "更多达人正在等待与您合作 — 如需解锁完整访问，只需",
    collaborationWithCreator: "与任意达人开启合作",
    or: "或",
    depositCampaignBudget: "充值活动预算。",
    unlockFullAccess: "解锁完整访问",
    // 调整提示
    notSeeingIdealMatches: "没有看到理想的匹配？",
    adjustYourInputs: "试试调整筛选条件",
    // 确认邀请列表相关
    confirmInviteList: {
      confirmDeleteTitle: "确认移除达人？",
      confirmDeleteTitleMultiple: "确认移除达人？",
      confirmDeleteContent: "您即将移除 1 位达人。一旦移除，他们将不再收到邀请或参与此次合作。此操作无法撤销。请仔细审查后再继续。",
      confirmDeleteContentMultiple: "您即将移除 {count} 位达人。一旦移除，他们将不再收到邀请或参与此次合作。此操作无法撤销。请仔细审查后再继续。",
      inviteSentSuccessSingle: `已成功向 1 位达人发送邀请！达人申请活动后，您可以在"合作管理"页面找到他们`,
      inviteSentSuccessMultiple: `已成功向 {count} 位达人发送邀请！达人申请活动后，您可以在"合作管理"页面找到他们`,
      selectCurrentPage: "选择当前页",
      confirmAllInvitations: "确认所有邀请",
      confirmInvite: "确认邀请",
      emptyStateMessage: "AhaCreator 正在努力为您审核达人。申请审核完成后，达人将显示在此处。",
      confirmAllInvitationsContent: "您即将向 {count} 位达人发送邀请。一旦发送，此操作无法撤销。请仔细审查后再继续。",
      confirmAllInvitationsTitle: "确认发送邀请？"
    }
  },

  // 企业解决方案模板模态框相关
  modalEnterpriseSolutionTemplates: {
    title: "邀请邮件模板示例",
    description: "这些模板经过上千次实验验证，能有效提升转化率。",
    templateNumber: "模板",
    subject: "主题：",
    emailBody: "正文：",
  },

  // 平台过滤器相关
  platformFilter: {
    allPlatforms: "全部平台",
    platforms: "平台",
  },

  // 待办事项列表相关
  todoList: {
    title: "待办事项",
    all: "全部",
    congratulations: "恭喜！本次活动暂无待办。",
  },

  // 图表报告相关
  chartsReport: {
    // 分组选项标签
    audience: "受众",
    platform: "平台",
    creative: "创意",
    // 空状态提示
    noDataYet: "暂无数据",
    // 视图选择
    viewBy: "查看维度",
    // 选择器占位符
    selectPerson: "选择人员",
  },

  // 报告页面相关
  reports: {
    // 标题和标签
    campaignPerformance: "整体表现",
    report: "报告",
    watchTutorial: "观看教程",
    // 报告类型
    campaign: "营销计划",
    influencer: "每个红人",
    // 操作按钮
    download: "下载",
    // 已发布内容
    publishedContent: "已发布内容",
    noPublishedContentYet: "暂未发布内容",
    // 其他标签
    for: "周期",
    // 表格列标题
    creatorName: "达人姓名",
    orderValue: "订单金额",
    commissionValue: "佣金金额",
    orderPlacementTime: "下单时间",
    commissionDueTime: "佣金到期时间",
    paymentTime: "付款时间",
    status: "状态",
    pay: "支付",
  },

  // 付款模态框相关
  paymentModal: {
    // 标题
    title: "付款详情",
    // 付款详情
    commissionAmount: "佣金金额",
    transactionFee: "交易手续费",
    transactionFeeDescription: "手续费取决于您的支付方式，由支付服务商收取。",
    freeCredits: "免费额度",
    total: "总计",
    // 按钮和操作
    confirmAndPay: "确认并支付",
    setup: "去设置",
    notNow: "暂不操作",
    // 错误和警告
    paymentFailed: "支付失败，请重试。",
    noAvailablePaymentMethod: "暂无可用支付方式",
    noPaymentMethodContent: "请先充值余额或绑定银行卡后，再确认达人。",
    // 安全提示
    guaranteedSafe: "安全可靠的支付保障",
    poweredBy: "技术支持",
  },

  // 报告表格相关
  reportTable: {
    actual: "现状",
  },

  // 报告表格头部相关
  reportTableHeader: {
    // 时间相关
    startedOn: "开始于",
    campaignPeriod: "活动周期",
    reportUpdateDate: "报告更新时间",
    // 其他信息
    objective: "目标",
    cost: "花费",
  },

  // 报告表格选择器相关
  reportTableSelector: {
    // 受众选择器
    allAudiences: "全部受众",
    pleaseSelect: "请选择",
    // 创意选择器
    allCreatives: "全部创意",
    // 平台选择器
    allPlatforms: "全部平台",
  },

  // 销售外联页面相关
  salesOutreach: {
    // 页面标题
    title: "邮件营销",
    // 表格列标题
    email: "邮箱",
    name: "姓名",
    profileHeadline: "个人简介",
    status: "状态",
    emailReply: "邮件回复",
    price: "价格",
    // 状态标签
    leadForwarded: "线索已转交",
    converted: "已转化",
    // 操作按钮
    pay: "支付",
    paid: "已支付",
    // 统计信息
    leadsPurchased: "已购线索",
    totalSent: "已发送",
    openRate: "打开率",
    replyRate: "回复率",
    convertedCount: "转化数量",
    totalQualifiedLeads: "数据库合格线索总数：",
    addMoreLeads: "添加更多线索",
    // 空状态提示
    emailWarmingUp: "邮箱预热中，约需 7 天以确保最佳外联效果。",
    emailTemplatesLeverage:
      "我们的邮件模板已被验证，累计为 300+ 企业带来 20,000+ 高质量线索",
  },

  // 添加更多线索模态框相关
  addMoreLeads: {
    // 模态框标题
    title: "添加更多线索",
    // 描述文本
    description: "还有 {availableLeads} 个合格线索可用。请输入您要添加的数量。",
    // 输入框占位符
    placeholder: "请输入购买的线索数量",
    // 错误提示
    numberMustBeGreaterThanZero: "数量必须大于 0！",
    enterNumberSmallerThan: "请输入小于 {availableLeads} 的数量！",
    // 按钮文本
    cancel: "取消",
    proceedToPayment: "去支付",
  },

  // 邮件详情组件相关
  emailDetails: {
    // 按钮文本
    payToUnlock: "支付后解锁此转化线索",
  },

  // 邮件付款模态框相关
  emailPaymentModal: {
    // 默认标题
    defaultTitle: "邮件营销付款详情",
    // 费用项目
    coldEmailInfra: "邮件营销基础服务",
    enterpriseSolutionCost: "企业方案费用",
    transactionFee: "交易手续费",
    freeCredits: "免费额度",
    total: "总计",
    // 费用说明
    coldEmailInfraDesc: "包含域名搭建、邮箱预热、外联等基础成本。",
    enterpriseSolutionDesc: "包含自定义域名搭建、定制推广链接等费用。",
    transactionFeeDesc: "手续费取决于您的支付方式，由支付服务商收取。",
    // 按钮文本
    confirmAndPay: "确认并支付",
    // 安全提示
    guaranteedSafe: "安全可靠的支付保障",
    poweredBy: "技术支持",
    // 错误和警告
    paymentFailed: "支付失败，请重试。",
    // 原始价格（划线价格）
    originalPrice: "原价",
  },

  // 议价提案相关
  proposedRate: {
    counter: "提交还价",
    negotiationPrice: "议价记录",
    makeACounterOffer: "议价记录",
    influencerMessage: "达人消息",
    brandMessage: "品牌消息",
    submitMyProposal: "提交我的报价",
    submitMyRate: "提交我的报价",
    yourCounterOffer: "你的还价",
    yourLatestQuote: "你的最新报价",
    yourLatestQuoteDesc: "你的最新报价正在被达人审核。你可以提交一个新的报价让达人审核。",
    price: "价格",
    messageToInfluencer: "给达人的消息 (可选)",
    messagePlaceholder: "分享你的理由 (预算限制, 更简单的交付) 并提及未来的合作机会",
    nonNegotiableTooltip: "该达人的报价不可议价。",
    nonBrandNegotiableTooltip: "本次报价已定为不可谈判。达人可以查看它，但不能进一步协商。",
    negotiatedPriceTooltip: "该达人可议价。",
    newLabel: "新功能！",
    nonNegotiableCheckbox: "若您的报价不可议价，请勾选此项。勾选后，达人只能同意或拒绝，请谨慎操作。",
    warningAlert: "该报价明显低于达人的报价。更接近达人的报价的报价更容易被接受。",
    errorAlert: "报价与达人的报价差距过大，可能被拒绝。",
    priceHistory: "价格历史",
    negotiationRecords: '议价记录',
    makeOfferNonNegotiable: "将此报价设为不可议价",
    makeOfferNonNegotiableDesc: "达人只能接受或拒绝此报价。",
    brandQuote: "品牌报价",
    influencerQuote: "达人报价",
  },
};
